import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const signout = createAsyncThunk(
  "signout/signoutUsers",
  async (payload, thunkAPI) => {
    try {
      
      const response = await api.get("signout");
      return response.data;
    } catch (error) {
      console.log(error)
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const signoutSlice = createSlice({
  name: "signout",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(signout.pending, (state) => {
        state.loading = true;
      })
      .addCase(signout.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(signout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default signoutSlice.reducer;
